const Header = ({ heading = null }: { heading: string | null }) => <h2 className="text-center mb-4">{heading}</h2>;

export default Header;
